// extracted by mini-css-extract-plugin
export default {"riskScoreCell":"RiskScoreCell_riskScoreCell__aohNP","green":"RiskScoreCell_green__NOdrD","red":"RiskScoreCell_red__YExlS","orange":"RiskScoreCell_orange__75+Ze"};